// @flow

import React, { type Node } from 'react';

type Props = {|
  +children: Node,
|};

export function NullPage({ children }: Props): Node {
  return (
    <>
      <h1>Null Checkout</h1>
      {children}
    </>
  );
}
